import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetChargeQuery } from 'src/core/service/charging-session.service';
import { ChargingSessionCard } from 'src/shared/charging-session-card/charging-session.card';
import { ChargingStatusCard } from 'src/shared/charging-status-card/charging-status.card';
import { Snackbar } from 'src/shared/snackbar/snackbar';

export function ChargingSessionDetail(): React.JSX.Element {
  const { chargingSessionId } = useParams();
  const { t } = useTranslation();

  const {
    data: chargingSession,
    isLoading: isLoadingChargingSession,
    isError: isChargingSessionError,
  } = useGetChargeQuery(chargingSessionId!, {
    skip: !chargingSessionId,
  });

  return (
    <>
      <ChargingSessionCard
        isPending={isLoadingChargingSession}
        chargingSessionId={chargingSessionId}
        chargingDuration={
          chargingSession?.stoppedAt
            ? new Date(chargingSession.stoppedAt).getTime() -
              new Date(chargingSession.startedAt).getTime()
            : undefined
        }
        locationName={chargingSession?.locationName}
        locationCity={chargingSession?.locationCity}
        startedAt={chargingSession?.startedAt}
        stoppedAt={chargingSession?.stoppedAt}
        energyDelivered={chargingSession?.energyDelivered}
        sessionId={chargingSession?.sessionId}
        cpoId={chargingSession?.cpoId}
        tokenUid={chargingSession?.tokenUid}
        contractId={chargingSession?.contractId}
        evseUid={chargingSession?.evseUid}
        locationId={chargingSession?.locationId}
        connectorId={chargingSession?.connectorId}
      />

      <ChargingStatusCard
        chargingSessionStatusList={chargingSession?.status}
        isPending={isLoadingChargingSession}
      />

      {isChargingSessionError && (
        <Snackbar
          variant="error"
          message={t('error.get-one-charging-session-query')}
        />
      )}
    </>
  );
}
